<div *ngIf="licenseStorage$ | async as licenseStorage" class="mc-spring-board">
  <div class="mc-spring-board-form-body">
    <div class="mc-license-subscription-detail-container">
      <span class="mc-license-subscription-detail-header">Storage</span>
      <span class="mc-fill-remaining-flex-space"></span>
      <span class="mc-license-subscription-capacity mc-text-muted">{{ licenseStorage.UsedStorageSpace | mcFileSize }} of
        <span *ngIf="isTrial">Unlimited</span>
        <span *ngIf="!isTrial">{{ licenseStorage.MaxStorageSpace | mcFileSize }} Used</span>
      </span>
    </div>
    <mat-progress-bar mode="determinate" color="usage-storage" [value]="isTrial ? 0 : (licenseStorage.UsedStorageSpace / licenseStorage.MaxStorageSpace) * 100"></mat-progress-bar>

    <div class="mc-license-subscription-detail-container">
      <span class="mc-license-subscription-detail-header">Authors</span>
      <span class="mc-fill-remaining-flex-space"></span>
      <span class="mc-license-subscription-capacity mc-text-muted">{{ licenseStorage.UsedAuthorSeats }} of
        <span *ngIf="isTrial">Unlimited</span>
        <span *ngIf="!isTrial">{{ licenseStorage.AuthorSeats }} Used</span>
      </span>
    </div>
    <mat-progress-bar mode="determinate" color="usage-authors" [value]="isTrial ? 0 : (licenseStorage.UsedAuthorSeats / licenseStorage.AuthorSeats) * 100"></mat-progress-bar>

    <div class="mc-license-subscription-detail-container">
      <span class="mc-license-subscription-detail-header">Subject Matter Experts</span>
      <span class="mc-fill-remaining-flex-space"></span>
      <span class="mc-license-subscription-capacity mc-text-muted">{{ licenseStorage.UsedSmeSeats }} of
        <span *ngIf="isTrial">Unlimited</span>
        <span *ngIf="!isTrial">{{ licenseStorage.SmeSeats }} Used</span>
      </span>
    </div>
    <mat-progress-bar mode="determinate" color="usage-smes" [value]="isTrial ? 0 : (licenseStorage.UsedSmeSeats / licenseStorage.SmeSeats) * 100"></mat-progress-bar>
  </div>
  <div class="mc-spring-board-footer">
    <button mat-raised-button class="mc-dialog-card-action-button" type="button" color="primary" (click)="openContactSalesDialog()">Contact Sales</button>
  </div>
</div>